import { render, staticRenderFns } from "./WapFrame.vue?vue&type=template&id=636818b5&scoped=true"
import script from "./WapFrame.vue?vue&type=script&lang=js"
export * from "./WapFrame.vue?vue&type=script&lang=js"
import style0 from "./WapFrame.vue?vue&type=style&index=0&id=636818b5&prod&lang=scss&scoped=true"
import style1 from "./WapFrame.vue?vue&type=style&index=1&id=636818b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636818b5",
  null
  
)

export default component.exports